// Module
var code = `<button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
<h3 class="margin-bottom">Additional Sources & Assemblies</h3>
<div class="margin-top margin-bottom">
    <div class="margin-bottom">
        The Map &amp; Reduce index methods can reference code from external source files.<br>
        In order for the index to compile, the relevant sources must be uploaded to the index definition.
    </div>
    <div>
        Additional source files can be uploaded in the <strong>Additional Sources Tab</strong>.<br>
        Additional assemblies that are referenced can be added in the <strong>Additional Assemblies Tab</strong>. (C# only)
    </div>
</div>
<hr>
`;
// Exports
export default code;